import { createValidator, minLength, maxLength } from 'src/helpers/validation';
import { ThankDonorModalData } from 'src/components/ThankingDonors/ThankDonorModal';

const rules = {
  thankYouMessage: [minLength(3), maxLength(200)],
};

export default createValidator<ThankDonorModalData>(rules);



// WEBPACK FOOTER //
// ./src/components/ThankingDonors/thankMessageValidation.ts